export const adminNews = {
  'admin.news.createPost.title': 'Create News Post',
  'admin.news.createPost.save': 'Save Post',
  'admin.news.createPost.saving': 'Saving...',
  'admin.news.createPost.success': 'Post created successfully',
  'admin.news.createPost.error': 'Failed to create post',
  'admin.news.createPost.titlePlaceholder': 'Enter post title',
  'admin.news.createPost.descriptionPlaceholder': 'Enter a brief description',
  'admin.news.createPost.contentPlaceholder': 'Write your post content here...',
  'admin.news.createPost.settings': 'Settings',
  'admin.news.createPost.publish': 'Publish',
  'admin.news.createPost.tags': 'Tags',
  'admin.news.createPost.selectTags': 'Select tags',
  'admin.news.createPost.videoUrl': 'Video URL',
  'admin.news.createPost.videoUrlPlaceholder': 'Enter YouTube or Vimeo URL',
  'admin.news.createPost.featuredImage': 'Featured Image',
  'admin.news.createPost.uploadImage': 'Upload Image',
  'admin.news.createPost.removeImage': 'Remove Image',
  'admin.news.createPost.translations': 'Translations',
  'admin.news.createPost.translate': 'Translate',
  'admin.news.createPost.translating': 'Translating...',
  'admin.news.createPost.translationPreview': 'Translation Preview',
};
